import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Rocket, Users, TrendingUp } from 'lucide-react';
import SignupFormModal from '../components/SignupFormModal';

export default function RoadmapPage() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
    const [modalButtonType, setModalButtonType] = useState('demo');
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const whyUpdatesReasons = [
        {
            Icon: Rocket,
            title: "Faster Response Times",
            description: "From 30 seconds to instant. Voice AI and predictive responses eliminate all waiting time.",
            color: "text-pink-500"
        },
        {
            Icon: Users,
            title: "Better Customer Experience",
            description: "Personalized conversations that remember context, preferences, and history across all channels.",
            color: "text-blue-500"
        },
        {
            Icon: TrendingUp,
            title: "Higher Converion Rates",
            description: "Predictive closing and autonomous negotiation mean more deals closed, faster.",
            color: "text-gray-600"
        }
    ];

    return (
        <div className="min-h-screen bg-white font-['Outfit',sans-serif] text-gray-900">
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
        
        .text-gradient {
          background: linear-gradient(135deg, #FF6B35 0%, #FFA500 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .feature-card {
          transition: all 0.3s ease;
        }

        .feature-card:hover {
          transform: translateY(-5px);
        }
      `}</style>

            {/* Navigation */}
            <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white'}`}>
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20">
                        <Link to="/" className="flex items-center gap-2">
                            <img
                                src="/logo-qorvix.png"
                                alt="Qorvix Logo"
                                className="h-10 w-auto"
                            />
                        </Link>
                        <div className="hidden lg:flex items-center space-x-8">
                            <Link to="/" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">Home</Link>
                            <Link to="/about" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">About</Link>
                            <Link to="/how-it-works" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">How it works</Link>
                            <Link to="/portfolio" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">Portfolio</Link>
                            <div className="relative group">
                                <button className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px] flex items-center gap-1">
                                    Resources
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                                    <div className="py-2">
                                        <a href="/documentation" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">Documentation</a>
                                        <a href="/integrations" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">Integration</a>
                                        <Link to="/faq" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">FAQs</Link>
                                        <a href="/help-center" className="block px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-orange-500 transition-colors">Help center</a>
                                        <Link to="/roadmap" className="block px-4 py-2.5 text-orange-500 bg-gray-50 transition-colors">Roadmap</Link>
                                    </div>
                                </div>
                            </div>
                            <Link to="/contact" className="text-gray-900 hover:text-orange-500 transition-colors font-medium text-[15px]">Contact us</Link>
                            <button onClick={() => {
                                setModalButtonType('demo');
                                setIsSignupModalOpen(true);
                            }} className="bg-transparent border-2 border-orange-500 text-orange-500 px-6 py-2.5 rounded-lg hover:bg-orange-500 hover:text-white transition-all font-medium text-[15px]">
                                Start Free Demo
                            </button>
                        </div>

                        <button
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className="lg:hidden text-gray-900"
                        >
                            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile Menu Modal - Add this after </nav> */}
            {mobileMenuOpen && (
                <div className="fixed inset-0 z-50 lg:hidden">
                    {/* Backdrop */}
                    <div className="fixed inset-0 bg-black/50" onClick={() => setMobileMenuOpen(false)}></div>

                    {/* Menu Panel */}
                    <div className="fixed top-8 left-1/2 -translate-x-1/2 w-[90%] max-w-sm bg-white rounded-3xl shadow-2xl p-8 z-50">
                        {/* Close Button */}
                        <button
                            onClick={() => setMobileMenuOpen(false)}
                            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                        >
                            <X size={24} />
                        </button>

                        {/* Menu Items */}
                        <nav className="mt-4 space-y-6">
                            <Link
                                to="/"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                Home
                            </Link>
                            <Link
                                to="/about"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                About
                            </Link>
                            <Link
                                to="/how-it-works"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                How it works
                            </Link>
                            <Link
                                to="/portfolio"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                portfolio
                            </Link>

                            {/* Resources Dropdown */}
                            <div>
                                <button className="w-full text-left text-lg font-medium text-gray-900 flex items-center gap-2">
                                    resources
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" className="mt-1">
                                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <div className="mt-4 ml-4 space-y-4">
                                    <Link
                                        to="/documentation"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Documentation
                                    </Link>
                                    <Link
                                        to="/integrations"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Integrations
                                    </Link>
                                    <Link
                                        to="/faq"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        FAQs
                                    </Link>
                                    <Link
                                        to="/help-center"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Help center
                                    </Link>
                                    <Link
                                        to="/roadmap"
                                        className="block text-base text-gray-700 hover:text-orange-500 transition-colors"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Roadmap
                                    </Link>
                                </div>
                            </div>

                            <Link
                                to="/contact"
                                className="block text-lg font-medium text-gray-900 hover:text-orange-500 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                Contact us
                            </Link>

                            {/* CTA Button */}
                            <button onClick={() => {
                                setModalButtonType('demo');
                                setIsSignupModalOpen(true);
                            }} className="text-lg font-medium text-orange-500 border-b-2 border-orange-500 pb-1">
                                Start free demo
                            </button>
                        </nav>
                    </div>
                </div>
            )}
            {/* Hero Section */}
            <section className="pt-32 pb-20 px-4 bg-gradient-to-br from-orange-50 via-white to-orange-50">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div>
                            <h1 className="text-5xl md:text-6xl font-bold mb-6">
                                Road Map
                            </h1>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                See what's coming next for Qorvix — from AI voice replies to predictive closing and total autonomy mode in 2026.
                            </p>
                        </div>
                        <div className="flex justify-center">
                            <img
                                src="https://images.unsplash.com/photo-1535378620166-273708d44e4c?w=400&h=400&fit=crop"
                                alt="Robot Assistant"
                                className="w-80 h-80 object-contain"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Instant Intelligence Update */}
            <section className="py-20 px-4 bg-white">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl md:text-5xl font-bold mb-4">
                            Instant Intelligence <span className="text-gradient">Update</span>
                        </h2>
                        <p className="text-lg text-gray-600">
                            Making AI even faster, smarter, and more natural
                        </p>
                    </div>

                    <div className="relative rounded-3xl overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=1200&h=600&fit=crop"
                            alt="AI Voice Reply"
                            className="w-full h-96 object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-cyan-900/80 to-transparent"></div>
                        <div className="absolute inset-0 p-12 flex flex-col justify-center max-w-2xl">
                            <div className="space-y-8 text-white">
                                <div>
                                    <h3 className="text-2xl font-bold mb-2">AI Voice Reply For Inbound Calls</h3>
                                    <p className="text-white/90">The AI can now answer phone calls with natural voice, handle inquiries, and book appointments through voice conversations.</p>
                                </div>
                                <div>
                                    <h3 className="text-2xl font-bold mb-2">Smart Tone Matching</h3>
                                    <p className="text-white/90">AI mirrors your personal communication style — whether formal, casual, enthusiastic, or technical. It learns from your past messages.</p>
                                </div>
                                <div>
                                    <h3 className="text-2xl font-bold mb-2">Ad-Triggered Chat Flow</h3>
                                    <p className="text-white/90">Lead clicks ad → instant personalized message. Zero delay, maximum conversion. Custom flows for each campaign.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Full Customer Memory */}
            <section className="py-20 px-4 bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl md:text-5xl font-bold mb-4">
                            Full Customer <span className="text-gradient">Memory</span>
                        </h2>
                        <p className="text-lg text-gray-600">
                            The AI remembers everything about every customer
                        </p>
                    </div>

                    <div className="grid lg:grid-cols-3 gap-6">
                        {/* Large Card */}
                        <div className="lg:col-span-3 relative rounded-3xl overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200&h=400&fit=crop"
                                alt="Persistent Memory"
                                className="w-full h-64 object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent"></div>
                            <div className="absolute inset-0 p-8 flex flex-col justify-end max-w-2xl">
                                <h3 className="text-3xl font-bold text-white mb-2">Persistent Memory Log</h3>
                                <p className="text-white/90">Each lead has a memory log. AI remembers details like name, budget, preferences, and picks up right where it left off — even months later.</p>
                            </div>
                        </div>

                        {/* Two Column Cards */}
                        <div className="lg:col-span-2 relative rounded-3xl overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&h=400&fit=crop"
                                alt="Cross-Channel Chat"
                                className="w-full h-64 object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent"></div>
                            <div className="absolute inset-0 p-8 flex flex-col justify-end">
                                <h3 className="text-3xl font-bold text-white mb-2">Smart Cross-Channel Chat</h3>
                                <p className="text-white/90">One unified inbox for WhatsApp, Email, Instagram DMs, and SMS. Switch channels seamlessly without losing context.</p>
                            </div>
                        </div>

                        <div className="relative rounded-3xl overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=600&h=400&fit=crop"
                                alt="Auto Upsell"
                                className="w-full h-64 object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70"></div>
                            <div className="absolute inset-0 p-6 flex flex-col justify-end">
                                <h3 className="text-2xl font-bold text-white mb-2">Auto Upsell Engine</h3>
                                <p className="text-white/90 text-sm">AI automatically sends follow-ups with new offers, upgrades, or related products based on purchase history and behavior.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Total Autonomy Mode */}
            <section className="py-20 px-4 bg-slate-900 text-white">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div>
                            <img
                                src="https://images.unsplash.com/photo-1639322537228-f710d846310a?w=600&h=600&fit=crop"
                                alt="AI Network"
                                className="rounded-2xl"
                            />
                        </div>
                        <div>
                            <h2 className="text-4xl md:text-5xl font-bold mb-6">
                                Total Autonomy Mode
                            </h2>
                            <p className="text-lg text-gray-300 mb-8">
                                From lead capture to payment verification — Qorvix connects every part of your workflow using AI-driven automations.
                            </p>
                            <div className="space-y-6">
                                <div className="flex items-start gap-4">
                                    <div className="w-6 h-6 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 mt-1">
                                        <div className="w-3 h-3 bg-white rounded-full"></div>
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-xl mb-1">Predictive Closing AI</h4>
                                        <p className="text-gray-300">Reads customer intent and negotiates deals within your preset price limits. The AI can offer discounts, bundle deals, and close sales autonomously.</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-4">
                                    <div className="w-6 h-6 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 mt-1">
                                        <div className="w-3 h-3 bg-white rounded-full"></div>
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-xl mb-1">Voice & Video Interaction</h4>
                                        <p className="text-gray-300">The AI can handle phone calls, voice notes, and video replies. Full multimedia customer engagement.</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-4">
                                    <div className="w-6 h-6 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 mt-1">
                                        <div className="w-3 h-3 bg-white rounded-full"></div>
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-xl mb-1">Industry Blueprints</h4>
                                        <p className="text-gray-300">Pre-built, industry-specific automation systems for automotive, real estate, healthcare, and retail. Deploy in hours, not weeks.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Your Voice Matters */}
            <section className="py-20 px-4 bg-white">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">
                        Your Voice <span className="text-gradient">Matters</span>
                    </h2>
                    <p className="text-xl text-gray-600 mb-8">
                        Help Us Build The Features You Need Most
                    </p>
                    <p className="text-lg text-gray-600 mb-8">
                        We're Constantly Evolving Qorvix Based On Real Feedback From Businesses Like Yours. Have A Feature Request Or Idea? We Want To Hear It.
                    </p>
                    <button className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:shadow-xl transition-all">
                        Submit Feature Request
                    </button>
                </div>
            </section>

            {/* Why These Updates Matter */}
            <section className="py-20 px-4 bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl font-bold mb-4">
                            Why These Updates <span className="text-gradient">Matter</span>
                        </h2>
                        <p className="text-lg text-gray-600">
                            Building Toward Complete Business Automation
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {whyUpdatesReasons.map((reason, index) => {
                            const IconComponent = reason.Icon;
                            return (
                                <div key={index} className="bg-white p-8 rounded-2xl text-center shadow-sm hover:shadow-lg transition-shadow">
                                    <div className="w-16 h-16 mx-auto mb-6">
                                        <IconComponent className={reason.color} size={64} strokeWidth={1.5} />
                                    </div>
                                    <h3 className="text-xl font-bold mb-3">{reason.title}</h3>
                                    <p className="text-gray-600 leading-relaxed">{reason.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Be First CTA */}
            <section className="py-20 px-4 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-300 to-purple-400"></div>
                <div className="max-w-4xl mx-auto relative z-10">
                    <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
                        Be First To Access New Features
                    </h2>
                    <p className="text-lg text-gray-700 mb-8">
                        Join Qorvix Today And Get Early Access To All Upcoming Releases
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4">
                        <button onClick={() => {
                            setModalButtonType('demo');
                            setIsSignupModalOpen(true);
                        }} className="bg-orange-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-orange-700 transition-all">
                            Get Early Access
                        </button>
                        <button onClick={() => {
                            setModalButtonType('demo');
                            setIsSignupModalOpen(true);
                        }} className="border-2 border-white bg-white text-gray-800 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all">
                            View Documents
                        </button>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-white py-12 px-4 border-t border-gray-200">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-4 gap-8 mb-8">
                        <div>
                            <h3 className="text-xl font-bold mb-4">
                                <span className="text-gradient">Qorvix</span> — Automate What Matters
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed mb-6">
                                Qorvix helps businesses automate workflows, connect tools, and scale faster using AI-powered systems. From CRM integrations to WhatsApp automations — we build smart, no-code solutions that work.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-bold mb-4">Contact</h4>
                            <div className="space-y-2 text-sm text-gray-600">
                                <p>London, England, UK</p>
                                <p>+44 7757 233260</p>
                                <p>Support@qorvix.ai</p>
                            </div>
                        </div>

                        <div>
                            <h4 className="font-bold mb-4">Company</h4>
                            <div className="space-y-2 text-sm">
                                <Link to="/" className="block text-gray-600 hover:text-gray-900 transition-colors">Home</Link>
                                <Link to="/about" className="block text-gray-600 hover:text-gray-900 transition-colors">About</Link>
                                <Link to="/portfolio" className="block text-gray-600 hover:text-gray-900 transition-colors">Portfolio</Link>
                                <Link to="/contact" className="block text-gray-600 hover:text-gray-900 transition-colors">Contact</Link>
                                <Link to="/how-it-works" className="block text-gray-600 hover:text-gray-900 transition-colors">How it works</Link>
                            </div>
                        </div>

                        <div>
                            <h4 className="font-bold mb-4">Resources</h4>
                            <div className="space-y-2 text-sm">
                                <Link to="/documentation" className="block text-gray-600 hover:text-gray-900 transition-colors">
                                    Documentation
                                </Link>

                                <Link to="/integrations" className="block text-gray-600 hover:text-gray-900 transition-colors">
                                    Integration
                                </Link>

                                <Link to="/faq" className="block text-gray-600 hover:text-gray-900 transition-colors">
                                    FAQs
                                </Link>

                                <Link to="/help-center" className="block text-gray-600 hover:text-gray-900 transition-colors">
                                    Help Center
                                </Link>

                                <Link to="/roadmap" className="block text-gray-600 hover:text-gray-900 transition-colors">
                                    Roadmap
                                </Link>
                                <Link to="/roadmap" className="block text-gray-600 hover:text-gray-900 transition-colors">Roadmap</Link>
                            </div>
                        </div>
                    </div>

                    <div className="pt-8 flex items-center justify-between border-t border-gray-200">
                        <div className="text-2xl font-bold text-gradient">Qorvix</div>
                        <div className="text-sm text-gray-600">
                            © Qorvix Technologies. All Rights Reserved. Built with purpose and precision by <span className="font-semibold">Qorvix Team</span>.
                        </div>
                    </div>
                </div>
            </footer>
            {/* Signup Modal */}
            <SignupFormModal
                isOpen={isSignupModalOpen}
                onClose={() => setIsSignupModalOpen(false)}
                buttonType={modalButtonType}
            />
        </div>
    );
}